module.exports = __webpack_public_path__ + "img/logo-4.2be269e3.svg";